module.exports = __webpack_public_path__ + "static/img/rz(12).3a5fde26.jpg";